<template>
  <div></div>
</template>

<script>
import Echo from "laravel-echo";

export default {
  name: "EdSocket",
  components: {},
  data: () => ({}),
  mounted() {},
  computed: {},
  methods: {
    inicialize() {
      if (!window.Echo) {
        let host = process.env.URL_SOCKET;

        if (!process.env.PRODUCTION) {
          host = process.env.PROTOCOL+ window.location.hostname;
        }

        window.io = require("socket.io-client");
        window.Echo = new Echo({
          broadcaster: "socket.io",
          encrypted: true,
          key: process.env.SOCKET_KEY,
          host: host,
          transports: ['websocket', 'polling', 'flashsocket']
        });
      }
    },

    publicChannel(_channel) {
      this.inicialize();
      return window.Echo.channel(this.$root.$session.env.app_name+'.'+this.$root.$session.cliente.logged.id+'.'+_channel);
    },

    privateChannel(_channel) {
      this.inicialize();
      return window.Echo.private(this.$root.$session.env.app_name+'.'+this.$root.$session.cliente.logged.id+'.'+_channel);
    },
  },
};
</script>



// WEBPACK FOOTER //
// EdSocket.vue?6fdc9ee3